/* eslint-disable no-underscore-dangle */
import axios from "axios";
import Keycloak from "keycloak-js";

class KeycloakAxios {
  constructor(configUrl) {
    this.kc = new Keycloak(configUrl ?? {
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
      realm: process.env.REACT_APP_KEYCLOAK_REALM,
      url: process.env.REACT_APP_KEYCLOAK_URL,
    });

    this.kc.onAuthLogout = () => {
      if (this.onAuthLogout) {
        setTimeout(this.onAuthLogout, 0);
      }
    };

    this.kc.onAuthError = err => {
      // eslint-disable-next-line no-console
      console.error("[Keycloak]: Authentication error", err);
    };

    this.kc.onAuthRefreshError = err => {
      // eslint-disable-next-line no-console
      console.error("[Keycloak]: Authentication refresh error", err);
    };
  }

  init = async options => {
    try {
      await this.kc.init(options);
      this._interceptAxiosRequest();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("[Keycloak]: Initialization failed", err);
    }
  };

  _interceptAxiosRequest = () => {
    axios.interceptors.request.use(async config => {
      const isTokenValid = await this.validateToken();

      if (isTokenValid) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${this.kc.token}`;
        // eslint-disable-next-line no-param-reassign
        config.headers["Content-Type"] = `application/json`;
      }
      return config;
    });
  };

  _getUserRoles = () => {
    const { tokenParsed } = this.kc;
    let roles = null;
    if (tokenParsed) {
      const entries = Object.entries(tokenParsed.resource_access);
      roles = entries.reduce((newObj, r) => {
        const name = r[0];
        const data = { ...newObj };
        data[name] = r[1].roles;
        return data;
      }, {});
    }
    return roles;
  };

  getUserData = () => {
    const { tokenParsed } = this.kc;

    return tokenParsed
      ? {
        username: tokenParsed.preferred_username,
        firstName: tokenParsed.given_name,
        lastName: tokenParsed.family_name,
        email: tokenParsed.email,
        roles: this._getUserRoles()
      }
      : null;
  };

  validateToken = async () => {
    try {
      // If the token expires within 5 seconds (default value for updateToken, can pass eny value in seconds) the token is refreshed.
      await this.kc.updateToken();
      return true;
    } catch {
      return false;
    }
  };

  login = options => {
    this.kc.login(options);
  };

  logout = options => {
    this.kc.logout(options);
  };

  getDeprecatedAuthenticated = () => {
    // Deprecated
    console.warn(
      "[KeycloakContext]: context[isAuthenticated/authenticated] property is Deprecated, use context.keycloak.authenticated"
    );
    return this.kc?.authenticated;
  };
}

export const initKeycloak = async (configUrl, options) => {
  const keycloak = new KeycloakAxios(configUrl);
  await keycloak.init(options);
  return keycloak;
};
